import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { localforage } from 'src/lib/serialization/localForage';
import { container } from 'src/StaticContainer';
import type { RootState } from 'src/store';
import { loadRecentlyUsedIndicators } from 'src/store/actions/recentlyUsedIndicators';

const log = container.get('Logger').getSubLogger({ name: 'sagas:recentlyUsedIndicators' });

const STORAGE_KEY = 'recentlyUsedIndicators';

export function* saveRecentlyUsedIndicators() {
    const recentlyUsedIndicators: RootState['recentlyUsedIndicators'] = yield select(
        (state: RootState) => state.recentlyUsedIndicators,
    );

    try {
        yield call([localforage, localforage.setItem], STORAGE_KEY, recentlyUsedIndicators);
    } catch {
        // Storage unavailable, ignore
    }
}

export function* loadRecentlyUsedIndicatorsFromStorage() {
    try {
        const stored: RootState['recentlyUsedIndicators'] | null = yield call(
            [localforage, localforage.getItem],
            STORAGE_KEY,
        );
        if (stored) {
            // Validate the structure
            if (
                stored &&
                typeof stored === 'object' &&
                Array.isArray(stored.scanner) &&
                Array.isArray(stored.screener)
            ) {
                yield put(loadRecentlyUsedIndicators(stored.scanner, stored.screener));
            } else {
                log.warn('Invalid recently used indicators data structure in storage', { stored });
            }
        }
    } catch (err) {
        log.warn('Failed to load recently used indicators from storage', { err });
    }
}

export function* recentlyUsedIndicatorsSagas() {
    yield all([
        loadRecentlyUsedIndicatorsFromStorage(), // Load on app start
        takeEvery(['recentlyUsedIndicators::add', 'recentlyUsedIndicators::load'], saveRecentlyUsedIndicators),
    ]);
}
